export default {
  YJS_WEBSOCKET: process.env.VUE_APP_YJS_WEBSOCKET || "ws://35.190.237.130",
  VUE_APP_PARENT_URL: process.env.VUE_APP_PARENT_URL || "http://localhost",
  VUE_APP_SPEECH_WEBSOCKET: process.env.VUE_APP_SPEECH_WEBSOCKET || "ws://localhost:9000/transcribe"
}
